export class Connector {
  uId: string;
  connectorName: string;
  description: string;
  status: string;  
  homepageURL: string;
  Logo: string;
  authType: string;
}
